/**
 * @generated SignedSource<<7eea14376c45a95294f68a90fb90b5c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FormMetadataStyleEnum = "ImageCenter" | "ImageLeft" | "NoImage";
export type FormMetadataTemplateEnum = "Basic" | "CompanyLong" | "CompanyShort" | "PasswordProtected" | "PasswordProtectedShort";
export type HubTemplateEnum = "HOME_LANDING_PAGE" | "HUB_TEMPLATE_03" | "SALES_LANDING_PAGE";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
export type Hub_Single_Query$variables = {
  id: string;
};
export type Hub_Single_Query$data = {
  readonly hub: {
    readonly __id: string;
    readonly author: {
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly slug: string | null | undefined;
        readonly username: string | null | undefined;
      };
    } | null | undefined;
    readonly connectionHubToHps: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly hubPage: {
            readonly node: {
              readonly connectionHpToCs: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly catalog: {
                      readonly node: {
                        readonly author: {
                          readonly node: {
                            readonly id: string;
                            readonly name: string | null | undefined;
                            readonly slug: string | null | undefined;
                            readonly username: string | null | undefined;
                          };
                        } | null | undefined;
                        readonly databaseId: number;
                        readonly id: string;
                        readonly link: string | null | undefined;
                        readonly searchResults: {
                          readonly extractiveAnswers: ReadonlyArray<{
                            readonly content: string | null | undefined;
                            readonly pageNumber: string | null | undefined;
                          } | null | undefined> | null | undefined;
                          readonly snippets: ReadonlyArray<{
                            readonly snippet: string | null | undefined;
                          } | null | undefined> | null | undefined;
                        } | null | undefined;
                        readonly status: string | null | undefined;
                        readonly statusSettings: {
                          readonly approved: {
                            readonly id: string | null | undefined;
                            readonly timestamp: string | null | undefined;
                            readonly user: {
                              readonly name: string | null | undefined;
                            } | null | undefined;
                          } | null | undefined;
                          readonly stateWhenApproved: {
                            readonly status: PostStatusEnum | null | undefined;
                            readonly uiPermission: {
                              readonly type: StatusUiPermissionEnum | null | undefined;
                            } | null | undefined;
                          } | null | undefined;
                          readonly status: PostStatusEnum | null | undefined;
                          readonly uiPermission: {
                            readonly type: StatusUiPermissionEnum | null | undefined;
                          } | null | undefined;
                        } | null | undefined;
                        readonly title: string | null | undefined;
                        readonly znglyContent: {
                          readonly aiSummary: string | null | undefined;
                          readonly contentEmbedHtml: string | null | undefined;
                          readonly contentFile: {
                            readonly mediaDetails: {
                              readonly sizes: ReadonlyArray<{
                                readonly name: string | null | undefined;
                                readonly sourceUrl: string | null | undefined;
                              } | null | undefined> | null | undefined;
                            } | null | undefined;
                            readonly mediaItemUrl: string | null | undefined;
                          } | null | undefined;
                          readonly contentLink: string | null | undefined;
                          readonly contentMediaName: string | null | undefined;
                          readonly contentMediaType: string | null | undefined;
                          readonly ctaLink: string | null | undefined;
                          readonly ctaName: string | null | undefined;
                          readonly featuredImageFile: {
                            readonly mediaDetails: {
                              readonly sizes: ReadonlyArray<{
                                readonly name: string | null | undefined;
                                readonly sourceUrl: string | null | undefined;
                              } | null | undefined> | null | undefined;
                            } | null | undefined;
                            readonly mediaItemUrl: string | null | undefined;
                          } | null | undefined;
                          readonly featuredImageLink: string | null | undefined;
                          readonly form: {
                            readonly node: {
                              readonly content: string | null | undefined;
                              readonly id: string;
                              readonly imageUrl: string | null | undefined;
                              readonly marketingConsent: boolean | null | undefined;
                              readonly metadata: {
                                readonly cookieExpiration: string | null | undefined;
                                readonly formStyle: FormMetadataStyleEnum | null | undefined;
                                readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
                                readonly submitSuccessText: string | null | undefined;
                              } | null | undefined;
                              readonly password: boolean | null | undefined;
                              readonly schema: string | null | undefined;
                              readonly title: string;
                              readonly uiSchema: string | null | undefined;
                            };
                          } | null | undefined;
                          readonly htmlDesc: string | null | undefined;
                          readonly shortText: string | null | undefined;
                        } | null | undefined;
                      };
                    } | null | undefined;
                    readonly catalogId: string | null | undefined;
                    readonly catalogOrder: number | null | undefined;
                  };
                }>;
              } | null | undefined;
              readonly description: string | null | undefined;
              readonly form: {
                readonly node: {
                  readonly content: string | null | undefined;
                  readonly id: string;
                  readonly imageUrl: string | null | undefined;
                  readonly marketingConsent: boolean | null | undefined;
                  readonly metadata: {
                    readonly cookieExpiration: string | null | undefined;
                    readonly formStyle: FormMetadataStyleEnum | null | undefined;
                    readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
                    readonly submitSuccessText: string | null | undefined;
                  } | null | undefined;
                  readonly password: boolean | null | undefined;
                  readonly schema: string | null | undefined;
                  readonly title: string;
                  readonly uiSchema: string | null | undefined;
                };
              } | null | undefined;
              readonly id: string;
              readonly title: string;
            };
          } | null | undefined;
          readonly pageIcon: string | null | undefined;
          readonly pageId: string | null | undefined;
          readonly pageOrder: number | null | undefined;
          readonly pageTitle: string | null | undefined;
        };
      }>;
    } | null | undefined;
    readonly created: string | null | undefined;
    readonly databaseId: number | null | undefined;
    readonly description: string | null | undefined;
    readonly group: string | null | undefined;
    readonly id: string;
    readonly metadata: {
      readonly design: {
        readonly borderRadius: number | null | undefined;
      } | null | undefined;
      readonly navMeta: ReadonlyArray<{
        readonly icon: string | null | undefined;
        readonly title: string | null | undefined;
        readonly znglist: {
          readonly id: string;
          readonly title: string | null | undefined;
          readonly znglist: {
            readonly znglyContents: ReadonlyArray<{
              readonly id?: string;
              readonly znglyContent?: {
                readonly contentFile: {
                  readonly mediaDetails: {
                    readonly sizes: ReadonlyArray<{
                      readonly name: string | null | undefined;
                      readonly sourceUrl: string | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly mediaItemUrl: string | null | undefined;
                } | null | undefined;
                readonly contentLink: string | null | undefined;
                readonly contentMediaName: string | null | undefined;
                readonly contentMediaType: string | null | undefined;
                readonly featuredImageFile: {
                  readonly mediaDetails: {
                    readonly sizes: ReadonlyArray<{
                      readonly name: string | null | undefined;
                      readonly sourceUrl: string | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly mediaItemUrl: string | null | undefined;
                } | null | undefined;
                readonly featuredImageLink: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly znglistId: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly shareIcons: ReadonlyArray<{
        readonly icon: string | null | undefined;
        readonly title: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly modified: string | null | undefined;
    readonly postOrder: number | null | undefined;
    readonly slug: string | null | undefined;
    readonly status: PostStatusEnum | null | undefined;
    readonly statusSettings: {
      readonly approved: {
        readonly id: string | null | undefined;
        readonly timestamp: string | null | undefined;
        readonly user: {
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly stateWhenApproved: {
        readonly status: PostStatusEnum | null | undefined;
        readonly uiPermission: {
          readonly type: StatusUiPermissionEnum | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly status: PostStatusEnum | null | undefined;
      readonly uiPermission: {
        readonly type: StatusUiPermissionEnum | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly template: HubTemplateEnum | null | undefined;
    readonly title: string;
    readonly userId: string | null | undefined;
    readonly userMeta: {
      readonly description: string | null | undefined;
      readonly image: {
        readonly id: string;
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
        readonly title: string | null | undefined;
      } | null | undefined;
      readonly imageId: string | null | undefined;
      readonly name: string | null | undefined;
      readonly role: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Hub_Single_Query = {
  response: Hub_Single_Query$data;
  variables: Hub_Single_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "StateWhenApproved",
  "kind": "LinkedField",
  "name": "stateWhenApproved",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusSettings",
  "kind": "LinkedField",
  "name": "statusSettings",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ApprovedState",
      "kind": "LinkedField",
      "name": "approved",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modified",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "group",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postOrder",
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWizAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDetails",
  "kind": "LinkedField",
  "name": "mediaDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "HubUserMeta",
  "kind": "LinkedField",
  "name": "userMeta",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaItem",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMetadataDesign",
  "kind": "LinkedField",
  "name": "design",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "borderRadius",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMetadataShareIcons",
  "kind": "LinkedField",
  "name": "shareIcons",
  "plural": true,
  "selections": [
    (v25/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "znglistId",
  "storageKey": null
},
v28 = [
  (v21/*: any*/),
  (v22/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "featuredImageFile",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featuredImageLink",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "contentFile",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLink",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentMediaName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentMediaType",
  "storageKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "order": "ASC",
      "orderBy": "PageOrder"
    }
  }
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageOrder",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageTitle",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageIcon",
  "storageKey": null
},
v40 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "statusIn": [
        "PUBLISH",
        "DRAFT"
      ]
    }
  }
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v42 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Form",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v41/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cookieExpiration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitSuccessText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingConsent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "password",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "HubPageToFormConnectionEdge",
  "kind": "LinkedField",
  "name": "form",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "order": "ASC",
      "orderBy": "CatalogOrder"
    }
  }
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "catalogId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "catalogOrder",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWithAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "AiSearchResults",
  "kind": "LinkedField",
  "name": "searchResults",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Snippet",
      "kind": "LinkedField",
      "name": "snippets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "snippet",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExtractiveAnswer",
      "kind": "LinkedField",
      "name": "extractiveAnswers",
      "plural": true,
      "selections": [
        (v41/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiSummary",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaLink",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaName",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentEmbedHtml",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortText",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "htmlDesc",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
  "kind": "LinkedField",
  "name": "form",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v57 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusSettings",
  "kind": "LinkedField",
  "name": "statusSettings",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ApprovedState",
      "kind": "LinkedField",
      "name": "approved",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v59 = [
  (v21/*: any*/),
  (v22/*: any*/),
  (v2/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "featuredImageFile",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaItem",
  "kind": "LinkedField",
  "name": "contentFile",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Hub_Single_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "hub",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HubMetadataNavMeta",
                "kind": "LinkedField",
                "name": "navMeta",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v4/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Znglist",
                    "kind": "LinkedField",
                    "name": "znglist",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Znglist_Znglist",
                        "kind": "LinkedField",
                        "name": "znglist",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "znglyContents",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ZnglyVideo_Znglycontent",
                                    "kind": "LinkedField",
                                    "name": "znglyContent",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ZnglyVideo",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": "HubToConnectionHubToHpsConnection",
            "kind": "LinkedField",
            "name": "connectionHubToHps",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HubToConnectionHubToHpsConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConnectionHubToHp",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": (v40/*: any*/),
                        "concreteType": "ConnectionHubToHpToHubPageConnectionEdge",
                        "kind": "LinkedField",
                        "name": "hubPage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HubPage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": (v44/*: any*/),
                                "concreteType": "HubPageToConnectionHpToCsConnection",
                                "kind": "LinkedField",
                                "name": "connectionHpToCs",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HubPageToConnectionHpToCsConnectionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ConnectionHpToC",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ConnectionHpToCToZnglyVideoConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "catalog",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ZnglyVideo",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v47/*: any*/),
                                                  (v3/*: any*/),
                                                  (v4/*: any*/),
                                                  (v48/*: any*/),
                                                  (v7/*: any*/),
                                                  (v12/*: any*/),
                                                  (v49/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ZnglyVideo_Znglycontent",
                                                    "kind": "LinkedField",
                                                    "name": "znglyContent",
                                                    "plural": false,
                                                    "selections": [
                                                      (v50/*: any*/),
                                                      (v51/*: any*/),
                                                      (v52/*: any*/),
                                                      (v34/*: any*/),
                                                      (v32/*: any*/),
                                                      (v53/*: any*/),
                                                      (v33/*: any*/),
                                                      (v31/*: any*/),
                                                      (v30/*: any*/),
                                                      (v29/*: any*/),
                                                      (v54/*: any*/),
                                                      (v55/*: any*/),
                                                      (v56/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "connectionHpToCs(first:100,where:{\"order\":\"ASC\",\"orderBy\":\"CatalogOrder\"})"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "hubPage(where:{\"statusIn\":[\"PUBLISH\",\"DRAFT\"]})"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "connectionHubToHps(where:{\"order\":\"ASC\",\"orderBy\":\"PageOrder\"})"
          },
          (v57/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Hub_Single_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "hub",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v58/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HubMetadataNavMeta",
                "kind": "LinkedField",
                "name": "navMeta",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v4/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Znglist",
                    "kind": "LinkedField",
                    "name": "znglist",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Znglist_Znglist",
                        "kind": "LinkedField",
                        "name": "znglist",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "znglyContents",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ZnglyVideo_Znglycontent",
                                    "kind": "LinkedField",
                                    "name": "znglyContent",
                                    "plural": false,
                                    "selections": [
                                      (v60/*: any*/),
                                      (v30/*: any*/),
                                      (v61/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ZnglyVideo",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v35/*: any*/),
            "concreteType": "HubToConnectionHubToHpsConnection",
            "kind": "LinkedField",
            "name": "connectionHubToHps",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HubToConnectionHubToHpsConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConnectionHubToHp",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": (v40/*: any*/),
                        "concreteType": "ConnectionHubToHpToHubPageConnectionEdge",
                        "kind": "LinkedField",
                        "name": "hubPage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HubPage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": (v44/*: any*/),
                                "concreteType": "HubPageToConnectionHpToCsConnection",
                                "kind": "LinkedField",
                                "name": "connectionHpToCs",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HubPageToConnectionHpToCsConnectionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ConnectionHpToC",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ConnectionHpToCToZnglyVideoConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "catalog",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ZnglyVideo",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v47/*: any*/),
                                                  (v3/*: any*/),
                                                  (v4/*: any*/),
                                                  (v48/*: any*/),
                                                  (v7/*: any*/),
                                                  (v58/*: any*/),
                                                  (v49/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ZnglyVideo_Znglycontent",
                                                    "kind": "LinkedField",
                                                    "name": "znglyContent",
                                                    "plural": false,
                                                    "selections": [
                                                      (v50/*: any*/),
                                                      (v51/*: any*/),
                                                      (v52/*: any*/),
                                                      (v34/*: any*/),
                                                      (v32/*: any*/),
                                                      (v53/*: any*/),
                                                      (v33/*: any*/),
                                                      (v61/*: any*/),
                                                      (v30/*: any*/),
                                                      (v60/*: any*/),
                                                      (v54/*: any*/),
                                                      (v55/*: any*/),
                                                      (v56/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "connectionHpToCs(first:100,where:{\"order\":\"ASC\",\"orderBy\":\"CatalogOrder\"})"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "hubPage(where:{\"statusIn\":[\"PUBLISH\",\"DRAFT\"]})"
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "connectionHubToHps(where:{\"order\":\"ASC\",\"orderBy\":\"PageOrder\"})"
          },
          (v57/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "18c7eafcc87f60522d0fe8befe7b5a76",
    "id": null,
    "metadata": {},
    "name": "Hub_Single_Query",
    "operationKind": "query",
    "text": "query Hub_Single_Query(\n  $id: ID!\n) {\n  hub(id: $id) {\n    id\n    databaseId\n    title\n    description\n    slug\n    status\n    statusSettings {\n      status\n      uiPermission {\n        type\n      }\n      stateWhenApproved {\n        status\n        uiPermission {\n          type\n        }\n      }\n      approved {\n        id\n        timestamp\n        user {\n          name\n          id\n        }\n      }\n    }\n    created\n    modified\n    template\n    group\n    postOrder\n    author {\n      node {\n        id\n        name\n        username\n        slug\n      }\n    }\n    userId\n    userMeta {\n      name\n      description\n      role\n      imageId\n      image {\n        id\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        title\n      }\n    }\n    metadata {\n      design {\n        borderRadius\n      }\n      shareIcons {\n        icon\n        title\n        url\n      }\n      navMeta {\n        icon\n        title\n        znglistId\n        znglist {\n          id\n          title\n          znglist {\n            znglyContents {\n              __typename\n              ... on ZnglyVideo {\n                id\n                znglyContent {\n                  featuredImageFile {\n                    mediaItemUrl\n                    mediaDetails {\n                      sizes {\n                        sourceUrl\n                        name\n                      }\n                    }\n                    id\n                  }\n                  featuredImageLink\n                  contentFile {\n                    mediaItemUrl\n                    mediaDetails {\n                      sizes {\n                        sourceUrl\n                        name\n                      }\n                    }\n                    id\n                  }\n                  contentLink\n                  contentMediaName\n                  contentMediaType\n                }\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    connectionHubToHps(where: {order: ASC, orderBy: PageOrder}) {\n      edges {\n        node {\n          pageId\n          pageOrder\n          pageTitle\n          pageIcon\n          hubPage(where: {statusIn: [PUBLISH, DRAFT]}) {\n            node {\n              id\n              title\n              description\n              form {\n                node {\n                  id\n                  title\n                  content\n                  schema\n                  uiSchema\n                  metadata {\n                    formStyle\n                    formTemplate\n                    cookieExpiration\n                    submitSuccessText\n                  }\n                  marketingConsent\n                  password\n                  imageUrl\n                }\n              }\n              connectionHpToCs(first: 100, where: {order: ASC, orderBy: CatalogOrder}) {\n                edges {\n                  node {\n                    catalogId\n                    catalogOrder\n                    catalog {\n                      node {\n                        id\n                        author {\n                          node {\n                            id\n                            name\n                            username\n                            slug\n                          }\n                        }\n                        databaseId\n                        title\n                        link\n                        status\n                        statusSettings {\n                          status\n                          uiPermission {\n                            type\n                          }\n                          stateWhenApproved {\n                            status\n                            uiPermission {\n                              type\n                            }\n                          }\n                          approved {\n                            id\n                            timestamp\n                            user {\n                              name\n                              id\n                            }\n                          }\n                        }\n                        searchResults {\n                          snippets {\n                            snippet\n                          }\n                          extractiveAnswers {\n                            content\n                            pageNumber\n                          }\n                        }\n                        znglyContent {\n                          aiSummary\n                          ctaLink\n                          ctaName\n                          contentMediaType\n                          contentLink\n                          contentEmbedHtml\n                          contentMediaName\n                          contentFile {\n                            mediaItemUrl\n                            mediaDetails {\n                              sizes {\n                                sourceUrl\n                                name\n                              }\n                            }\n                            id\n                          }\n                          featuredImageLink\n                          featuredImageFile {\n                            mediaItemUrl\n                            mediaDetails {\n                              sizes {\n                                sourceUrl\n                                name\n                              }\n                            }\n                            id\n                          }\n                          shortText\n                          htmlDesc\n                          form {\n                            node {\n                              id\n                              title\n                              content\n                              schema\n                              uiSchema\n                              metadata {\n                                formStyle\n                                formTemplate\n                                cookieExpiration\n                                submitSuccessText\n                              }\n                              marketingConsent\n                              password\n                              imageUrl\n                            }\n                          }\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "784de48be9a5fd9869e6e2aa35cfbb1f";

export default node;
